import React, { FC } from 'react';

type AppCardProps = {
    className?: string;
    children?: React.ReactNode;
}

const AppCard: FC<AppCardProps> = (props) => {
  return (
    <div className={'dx-card responsive-paddings ' + (props.className ? props.className : '')}>
      {
        props.children
      }
    </div>
  );
};


export default AppCard;
